export default __webpack_public_path__ + "static/media/Bracers of the Farseeker.7f458789.jpg";